import {Injectable} from '@angular/core';
import {TemplatePortal} from '@angular/cdk/portal';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

/**
 * Este servicio coordina la búsqueda entre el header y el table component
 * que se esté mostrando.
 */
@Injectable({
    providedIn: 'root'
})
export class SearchService {
    private _currentSearch = '';
    private _search: Subject<string> = new Subject();
    public hideSearch = false;
    /** Embudo de filtros de la tabla que se esté mostrando: el header lo pinta junto a la búsqueda */
    private _embudo = new BehaviorSubject<TemplatePortal | null>(null);

    get search(): Observable<string> {
        return this._search;
    }
    get currentSearch(): string|null {
        return this._currentSearch;
    }
    set currentSearch(value: string|null) {
        if (this.currentSearch !== value) {
            this._currentSearch = value;
            this._search.next(this._currentSearch);
        }
    }

    get embudo(): Observable<TemplatePortal | null> {
        return this._embudo;
    }

    ponerEmbudo(embudo: TemplatePortal) {
        this._embudo.next(embudo);
    }

    /** Solo lo quita si sigue siendo el suyo: la tabla nueva puede haberlo puesto ya */
    quitarEmbudo(embudo: TemplatePortal) {
        if (this._embudo.value === embudo) {
            this._embudo.next(null);
        }
    }
}
